import { render, staticRenderFns } from "./AddUpdateDialog.vue?vue&type=template&id=452b715e&scoped=true"
import script from "./AddUpdateDialog.vue?vue&type=script&lang=js"
export * from "./AddUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateDialog.vue?vue&type=style&index=0&id=452b715e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b715e",
  null
  
)

export default component.exports